// all values are normalized to days, a month has 31 days
export const DAYS_PER_MONTH = 31;
export const EVERY_WEEK = 7;
export const EVERY_2_WEEKS = 14;
export const EVERY_4_WEEKS = 28;
export const EVERY_MONTH = DAYS_PER_MONTH;
export const EVERY_3_MONTHS = 3 * DAYS_PER_MONTH;
export const EVERY_6_MONTHS = 6 * DAYS_PER_MONTH;
export const EVERY_12_MONTHS = 12 * DAYS_PER_MONTH;

/**
 * Formats the given amount as price
 *
 * @param {number} amount
 * @returns {string}
 */
export function formatAmount (amount)
{
	let cents = "" + (amount % 100);

	if (cents.length === 1)
	{
		cents = `0${cents}`;
	}

	return `${Math.floor(amount / 100)},${cents} €`;
}

/**
 * Formats the interval
 *
 * @param {number} interval
 * @returns {string}
 */
export function formatInterval (interval)
{
	switch (interval)
	{
	case EVERY_WEEK:
		return "pro Woche";

	case EVERY_2_WEEKS:
		return "zweiwöchentlich";

	case EVERY_4_WEEKS:
		return "vier Wochen";

	case EVERY_MONTH:
		return "monatlich";

	case EVERY_3_MONTHS:
		return "je Quartal";

	case EVERY_6_MONTHS:
		return "halbjährlich";

	case EVERY_12_MONTHS:
		return "jährlich";

	default:
		return `alle ${Math.round(interval / 7)} Wochen`;
	}
}

/**
 * Formats the given price
 *
 * @param {null|{amount: number, interval: number}} price
 * @returns {?string}
 */
export function formatPrice (price)
{
	return price !== null
		? `${formatAmount(price.amount)} / ${formatInterval(price.interval)}`
		: null;
}
